<script setup>
import { computed, ref } from 'vue'
import MtModal from '@/components/shared/modal.vue'
import MtInput from '@/components/shared/mt-input.vue'
import { asyncComputed } from '@/utils/asyncComputed'
import { request } from '@/utils/request'

const props = defineProps({
    fsyms: {
        type: Array,
        required: true,
    },
    value: {
        type: String,
    },
})

const emit = defineEmits(['update:value'])

const OTHER_VALUE = '_OTHER_'

const boundValue = computed({
    get() {
        return other.value ? OTHER_VALUE : props.value
    },
    set(v) {
        if (v !== OTHER_VALUE) {
            emit('update:value', v)
            return true
        } else {
            other.value = true
            return false
        }
    },
})

const other = ref(false)
const otherFsymId = ref(null)

const otherFsym = asyncComputed(async () => {
    if (otherFsymId.value?.length === 8) {
        return (await request.get(`/api/providers/factset/fsyms/${otherFsymId.value}`))[0] ?? null
    }
    return null
}, null)

function setOther() {
    boundValue.value = otherFsymId.value.toUpperCase()
    clearOther()
}

function clearOther() {
    other.value = null
    otherFsymId.value = null
}
</script>
<template>
    <span>
        <select v-model="boundValue">
            <option :value="null">-</option>
            <option v-for="fsym in fsyms" :key="fsym.fsymId" :value="fsym.fsymId">
                {{ fsym.display }}
            </option>
            <option :value="OTHER_VALUE">Other...</option>
        </select>

        <MtModal v-if="other" @dismiss="clearOther">
            <MtInput label="FsymId" v-model="otherFsymId" />
            <pre v-if="otherFsym">{{ JSON.stringify(otherFsym, null, 2) }}</pre>
            <div class="button-group">
                <button class="secondary" @click.prevent="clearOther">Cancel</button>
                <button class="primary" @click.prevent="setOther" :disabled="!otherFsym">Save</button>
            </div>
        </MtModal>
    </span>
</template>
